import { useEffect } from 'react'

import type { DefinitionItem, DefinitionProps } from './definition.types'

import Box from '../box'
import { styled, useStyleConfig, vui } from '../core'
import Icon from '../icon'
import P from '../p'
import { cs, isArray } from '../utils'

export const DefinitionItemKey = styled.dtBox``
export const DefinitionItemValue = styled.ddBox``

export const DefinitionContent = vui<'dl', DefinitionProps>((props, ref) => {
  const { startIcon, endIcon, iconLeft, iconRight, isLabelBold, isValueBold, items, orientation } =
    props as DefinitionProps

  const resolvedStartIcon = startIcon ?? iconLeft
  const resolvedEndIcon = endIcon ?? iconRight

  const styles = useStyleConfig('Definition', props)

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (iconLeft !== undefined) {
        console.warn('[Definition] `iconLeft` is deprecated. Use `startIcon` instead.')
      }
      if (iconRight !== undefined) {
        console.warn('[Definition] `iconRight` is deprecated. Use `endIcon` instead.')
      }
    }
  }, [iconLeft, iconRight])

  return (
    <>
      {isArray<DefinitionItem>(items)
        ? items.map(({ key, value, ...props }, index) => (
            <Box className="vui-definitionItemWrapper" key={index} ref={ref}>
              <DefinitionItemKey fontWeight={isLabelBold ? 'demi' : 'default'} {...styles.dt}>
                {props.keyHasIcon && resolvedStartIcon && (
                  <Icon className={cs('vui-definitionIcon')} name={resolvedStartIcon} {...styles.icon} />
                )}
                {key}
                {props.keyHasIcon && resolvedEndIcon && (
                  <Icon className={cs('vui-definitionIcon')} name={resolvedEndIcon} {...styles.icon} />
                )}
              </DefinitionItemKey>
              {isArray(value) ? (
                <DefinitionItemValue
                  key={index}
                  display="block"
                  fontWeight={isValueBold ? 'demi' : 'default'}
                  {...styles.dd}
                >
                  {orientation === 'horizontal'
                    ? value.join(', ')
                    : value.map((value, index) => (
                        <P display="flex" key={index + value}>
                          {props.valueHasIcon && resolvedStartIcon && (
                            <Icon className={cs('vui-definitionIcon')} name={resolvedStartIcon} {...styles.icon} />
                          )}
                          {value}
                          {props.valueHasIcon && resolvedEndIcon && (
                            <Icon className={cs('vui-definitionIcon')} name={resolvedEndIcon} {...styles.icon} />
                          )}
                        </P>
                      ))}
                  {}
                </DefinitionItemValue>
              ) : (
                <DefinitionItemValue fontWeight={isValueBold ? 'demi' : 'default'} {...styles.dd}>
                  {props.valueHasIcon && resolvedStartIcon && (
                    <Icon className={cs('vui-definitionIcon')} name={resolvedStartIcon} {...styles.icon} />
                  )}
                  {value}
                  {props.valueHasIcon && resolvedEndIcon && (
                    <Icon className={cs('vui-definitionIcon')} name={resolvedEndIcon} {...styles.icon} />
                  )}
                </DefinitionItemValue>
              )}
            </Box>
          ))
        : items}
    </>
  )
})

DefinitionContent.displayName = 'DefinitionContent'

export default DefinitionContent
